import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import ca from "./ca/index";
import de from "./de/index";
import en from "./en/index";
import es from "./es/index";
import nlBE from "./nl-BE/index";
import fr from "./fr/index";
import it from "./it/index";
import nl from "./nl/index";
import pl from "./pl/index";
import ro from "./ro/index";
import lb from "./lb/index";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ca,
      de,
      en,
      es,
      // Key must match the resolved language code exactly; the object-shorthand
      // `nlBE` never matched `nl-BE`, so nl-BE users silently fell back to en.
      "nl-BE": nlBE,
      fr,
      it,
      nl,
      pl,
      ro,
      lb
    },
    fallbackLng: "en",
    defaultNS: "default",
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"], 
      htmlTag: document.documentElement,
      convertDetectedLanguage: (lng: string | string[]) => {
        // Convertir les codes de langue du navigateur vers les codes supportés
        const supportedLngs = ["ca", "de", "en", "es", "nl-BE", "fr", "it", "nl", "pl", "ro", "lb"];
        
        // S'assurer que lng est une chaîne
        const lngStr = Array.isArray(lng) ? lng[0] : (typeof lng === "string" ? lng : "");
        if (!lngStr) return "en";
        
        const langCode = lngStr.split("-")[0].split("_")[0];
        
        // Migration: accepter l'ancien format nl_BE et le convertir en nl-BE
        if (lngStr === "nl-BE" || lngStr === "nl_BE") return "nl-BE";
        if (lngStr === "lb-LU" || lngStr === "lb_LU") return "lb";
        
        if (supportedLngs.includes(lngStr)) return lngStr;
        
        if (supportedLngs.includes(langCode)) return langCode;
        
        return "en";
      }
    },
    supportedLngs: ["ca", "de", "en", "es", "nl-BE", "fr", "it", "nl", "pl", "ro", "lb"]
  });

export const t = i18n.t;
export default i18n;
